module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"interests":"Interessen","noInterestCategoriesAvailable":"Keine Interessenkategorien verfügbar."},"en":{"interests":"Interests","noInterestCategoriesAvailable":"No interest categories available."}}')
  delete Component.options._Ctor
}
